<script setup lang="ts">
import type { Person } from '~/app/types/person';

const props = withDefaults(defineProps<{
  person?: Person;
  size?: 1 | 2 | 3 | 4 | 5; // Add more sizes as needed
}>(), {
  person: undefined,
  size: 3,
});
</script>

<template>
  <BaseImage
    v-if="props.person?.image"
    :image="props.person.image"
    :alt="props.person.name"
    :title="props.person.name"
    :width="96"
    :height="96"
    :class="`c-profile-picture size--${props.size}`"
  />
</template>

<style scoped>
.c-profile-picture {
  /* Default (size 3) */
  --size-tablet: 96px;
  --size: 72px;

  border-radius: 100%;
  border: 1px solid var(--profile-picture-border-color);
  object-fit: cover;
  display: inline-block;

  width: var(--size);
  height: var(--size);

  @screen tablet-wide {
    width: var(--size-tablet);
    height: var(--size-tablet);
  }
}

.size--0 {
  --size-tablet: 18px;
  --size: calc(var(--size-tablet) / 1.33);
}

.size--1 {
  --size-tablet: 32px;
  --size: calc(var(--size-tablet) / 1.33);
}

.size--2 {
  --size-tablet: 56px;
  --size: calc(var(--size-tablet) / 1.33);
}

.size--4 {
  --size-tablet: 164px;
  --size: calc(var(--size-tablet) / 1.33);
}

.size--5 {
  --size-tablet: 228px;
  --size: calc(var(--size-tablet) / 1.33);
}
</style>
